export const HorizonCountryCodeByInternalIdMap = {
  // Afghanistan
  92: 'af',
  
  // Albania
  8: 'al',
  
  // Algeria
  122: 'dz',
  
  // Andorra
  9: 'ad',
  
  // Angola
  123: 'ao',
  
  // Antigua and Barbuda
  67: 'ag',
  
  // Argentina
  193: 'ar',

  // Armenia
  62: 'am',

  // Aruba
  68: 'aw',

  // Australia
  216: 'au',

  // Austria
  10: 'at',

  // Azerbaijan
  64: 'az',

  // Bahamas, The
  69: 'bs',

  // Bahrain
  124: 'bh',

  // Bangladesh
  93: 'bd',

  // Barbados
  70: 'bb',

  // Belarus
  11: 'by',

  // Belgium
  12: 'be',

  // Belize
  194: 'bz',

  // Benin
  125: 'bj',

  // Bermuda
  90: 'bm',

  // Bhutan
  94: 'bt',

  // Bolivia
  195: 'bo',

  // Bosnia and Herzegovina
  13: 'ba',

  // Botswana
  126: 'bw',

  // Brazil
  196: 'br',

  // Brunei
  95: 'bn',

  // Bulgaria
  14: 'bg',

  // Burkina Faso
  127: 'bf',

  // Burundi
  128: 'bi',

  // Cambodia
  96: 'kh',

  // Cameroon
  129: 'cm',

  // Canada
  3: 'ca',

  // Cape Verde
  130: 'cv',

  // Cayman Islands
  72: 'ky',

  // Central African Republic
  131: 'cf',

  // Chad
  132: 'td',

  // Chile
  197: 'cl',

  // China
  98: 'cn',

  // Colombia
  198: 'co',

  // Comoros
  162: 'km',

  // Congo, Democratic Republic of
  133: 'cd',

  // Congo, The Republic of
  134: 'cg',

  // Cook Islands
  217: 'ck',

  // Costa Rica
  199: 'cr',

  // Cote d'Ivoire
  135: 'ci',

  // Croatia
  15: 'hr',

  // Cuba
  73: 'cu',

  // Curacao
  16353: 'cw',

  // Cyprus
  16: 'cy',

  // Czech Republic
  18: 'cz',

  // Denmark
  19: 'dk',

  // Djibouti
  136: 'dj',

  // Dominica
  74: 'dm',

  // Dominican Republic
  75: 'do',

  // Ecuador
  200: 'ec',

  // Egypt
  137: 'eg',

  // El Salvador
  201: 'sv',

  // Equatorial Guinea
  138: 'gq',

  // Eritrea
  139: 'er',

  // Estonia
  20: 'ee',

  // Eswatini
  178: 'sz',

  // Ethiopia
  140: 'et',

  // Fiji
  219: 'fj',

  // Finland
  22: 'fi',

  // France
  23: 'fr',

  // Gabon
  144: 'ga',

  // Gambia, The
  145: 'gm',

  // Georgia
  63: 'ge',

  // Germany
  24: 'de',

  // Ghana
  146: 'gh',

  // Greece
  26: 'gr',

  // Grenada
  76: 'gd',

  // Guatemala
  205: 'gt',

  // Guinea
  147: 'gn',

  // Guinea-Bissau
  148: 'gw',

  // Guyana
  204: 'gy',

  // Haiti
  78: 'ht',

  // Honduras
  206: 'hn',

  // Hungary
  30: 'hu',

  // Iceland
  28: 'is',

  // India
  100: 'in',

  // Indonesia
  222: 'id',

  // Iran
  141: 'ir',

  // Iraq
  142: 'iq',

  // Ireland
  288: 'ie',

  // Israel
  143: 'il',

  // Italy
  32: 'it',

  // Jamaica
  79: 'jm',

  // Japan
  101: 'jp',

  // Jordan
  149: 'jo',

  // Kazakhstan
  102: 'kz',

  // Kenya
  150: 'ke',

  // Kiribati
  223: 'ki',

  // Kosovo
  57: 'xk',

  // Kuwait
  151: 'kw',

  // Kyrgyzstan
  103: 'kg',

  // Laos
  104: 'la',

  // Latvia
  33: 'lv',

  // Lebanon
  152: 'lb',

  // Lesotho
  153: 'ls',

  // Liberia
  154: 'lr',

  // Libya
  155: 'ly',

  // Liechtenstein
  34: 'li',

  // Lithuania
  35: 'lt',

  // Luxembourg
  36: 'lu',

  // Madagascar
  156: 'mg',

  // Malawi
  157: 'mw',

  // Malaysia
  120: 'my',

  // Maldives
  119: 'mv',

  // Mali
  158: 'ml',

  // Malta
  38: 'mt',

  // Marshall Islands
  224: 'mh',

  // Mauritania
  159: 'mr',

  // Mauritius
  160: 'mu',

  // Mexico
  4: 'mx',

  // Micronesia, Federated States of
  225: 'fm',

  // Moldova
  39: 'md',

  // Monaco
  40: 'mc',

  // Mongolia
  106: 'mn',

  // Montenegro
  11813: 'me',

  // Morocco
  163: 'ma',

  // Mozambique
  164: 'mz',

  // Myanmar
  97: 'mm',

  // Namibia
  165: 'na',

  // Nauru
  226: 'nr',

  // Nepal
  107: 'np',

  // Netherlands
  41: 'nl',

  // New Zealand
  228: 'nz',

  // Nicaragua
  207: 'ni',

  // Niger
  166: 'ne',

  // Nigeria
  167: 'ng',

  // Niue
  415: 'nu',

  // North Korea
  108: 'kp',

  // North Macedonia
  37: 'mk',

  // Northern Cyprus
  17: 'qn',

  // Northern Mariana Islands
  229: 'mp',

  // Norway
  42: 'no',

  // Oman
  168: 'om',

  // Pakistan
  109: 'pk',

  // Palau
  230: 'pw',

  // Palestinian Territories
  185: 'ps',

  // Panama
  208: 'pa',

  // Papua New Guinea
  231: 'pg',

  // Paraguay
  209: 'py',

  // Peru
  210: 'pe',

  // Philippines
  232: 'ph',

  // Poland
  43: 'pl',

  // Portugal
  44: 'pt',

  // Puerto Rico
  83: 'pr',

  // Qatar
  169: 'qa',

  // Romania
  45: 'ro',

  // Russia
  46: 'ru',

  // Rwanda
  171: 'rw',

  // Saint Kitts and Nevis
  84: 'kn',

  // Saint Lucia
  85: 'lc',

  // Saint Vincent and the Grenadines
  86: 'vc',

  // Samoa
  234: 'ws',

  // San Marino
  47: 'sm',

  // Sao Tome and Principe
  172: 'st',

  // Saudi Arabia
  191: 'sa',

  // Senegal
  173: 'sn',

  // Serbia
  48: 'rs',

  // Seychelles
  190: 'sc',

  // Sierra Leone
  174: 'sl',

  // Singapore
  110: 'sg',

  // Sint Maarten
  82: 'sx',

  // Slovakia
  49: 'sk',

  // Slovenia
  50: 'si',

  // Solomon Islands
  235: 'sb',

  // Somalia
  175: 'so',

  // South Africa
  176: 'za',

  // South Korea
  111: 'kr',

  // South Sudan
  16573: 'ss',

  // Spain
  51: 'es',

  // Sri Lanka
  112: 'lk',

  // Sudan
  177: 'sd',

  // Suriname
  211: 'sr',

  // Sweden
  52: 'se',

  // Switzerland
  53: 'ch',

  // Syria
  179: 'sy',

  // Taiwan
  113: 'tw',

  // Tajikistan
  114: 'tj',

  // Tanzania
  180: 'tz',

  // Thailand
  115: 'th',

  // Timor-Leste
  218: 'tl',

  // Togo
  181: 'tg',

  // Tokelau
  10643: 'tk',

  // Tonga
  236: 'to',

  // Trinidad and Tobago
  87: 'tt',

  // Tunisia
  182: 'tn',

  // Turkey
  54: 'tr',

  // Turkmenistan
  116: 'tm',

  // Tuvalu
  237: 'tv',

  // Uganda
  183: 'ug',

  // Ukraine
  55: 'ua',

  // United Arab Emirates
  184: 'ae',

  // United Kingdom
  917: 'gb',

  // United States
  6: 'us',

  // Uruguay
  212: 'uy',

  // Uzbekistan
  117: 'uz',

  // Vanuatu
  238: 'vu',

  // Vatican City
  29: 'va',

  // Venezuela
  213: 've',

  // Vietnam
  118: 'vn',

  // Western Sahara
  186: 'eh',

  // Yemen
  187: 'ye',

  // Zambia
  188: 'zm',

  // Zimbabwe
  189: 'zw'
};
